import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { ReleaseNotes } from './releasenotes';
@Injectable({
  providedIn: 'root'
})
export class ReleasenotesService {

  constructor(private httpClient: HttpClient) { }
  baseUrl: string = environment.serviceUrl;
  Get(): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/ReleaseNotesApi/GetReleaseNotes');
  }
}
